export const AlertMixin = {
    methods: {
        errorMessage (title, message)  {
            this._displayMessage(title, message, "error")
        },
        
        successMessage(title, message) {
            this._displayMessage(title, message, "success")
        },

        warningMessage(title, message) {
            this._displayMessage(title, message, "warning")
        },

        _displayMessage(title, message, type) {
            this.$swal(title, message, type)
        }
    }
}